// extracted by mini-css-extract-plugin
module.exports = {"feedBack":"feedBack--2HT2R"};